const { createEnum } = require("./utils/enum");

exports.COUNTRIES_RAW = require("../countries");
exports.COUNTRIES_ENUM = require("../countries").reduce(
  (acc, [value, label]) => {
    acc.push(createEnum(value, label));
    return acc;
  },
  []
);
